import { styled } from "styled-components";

export const Fieldset = styled.fieldset<{ $error?: boolean }>`
    border-radius: 5px;
    border: ${props => props.$error ? '1px solid lightcoral' : '1px solid lightgrey'};
    padding: 5px 10px;
    width: 100%;
    height: ${props => props.$error ? 'auto' : 50 + 'px' };
`;

export const Legend = styled.legend<{ $error?: boolean }>`
    font-family: Roboto-Thin;
    font-size: 0.8rem;
    color: ${props => props.$error ? 'red' : 'initial'}
`;

export  const Error = styled.p`
    margin: 0;
    padding: 0;
    padding-top: 10px;
    padding-inline: 5px;
    font-size: 0.7rem;
    color: red;
`;